<H1> Counter<app-loader [status]="loaderStatus"></app-loader></H1>

<div *ngFor='let in of counter(120) ;let i = index'>
    <app-counterdetails [refNumber] = "i" ></app-counterdetails>
</div>




